/**
 * Admin dashboard component.
 *
 * Displays user statistics using StatCard components.
 * Data fetching handled by runtime, this component just renders.
 */

import * as stylex from "@stylexjs/stylex";

import { alert, grid, spacing, text } from "@animus/primaris";

import { StatCard } from "../stat-card/index.ts";

interface DashboardStat {
  title: string;
  value: number;
  color: "blue" | "red" | "green";
  icon?: string;
}

interface AdminDashboardProps {
  stats: DashboardStat[];
  isLoading?: boolean;
  error?: string | null;
}

function AdminDashboard({ stats, isLoading, error }: AdminDashboardProps) {
  return (
    <div>
      <h1 {...stylex.props(spacing.mb8, text.bold, text["2xl"], text.white)}>
        Dashboard
      </h1>

      {error && <div {...stylex.props(alert.error)}>{error}</div>}

      {isLoading ? (
        <p {...stylex.props(text.muted)}>Loading stats...</p>
      ) : (
        <div {...stylex.props(grid.cols3, grid.gap6)}>
          {stats.map((stat) => (
            <StatCard
              color={stat.color}
              key={stat.title}
              title={stat.title}
              value={stat.value}
              {...(stat.icon !== undefined && { icon: stat.icon })}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export { AdminDashboard, type AdminDashboardProps, type DashboardStat };
